import { useModal } from "@/features/modal/ModalStackManager";
import { machineMockData } from "@/mock/mockMachineData";
import { machineCNCData } from "@/pages/cms/cncDummy";
import { Box, Button, Flex, Select, Table, TextInput } from "@mantine/core";
import { useState } from "react";

// TO BE : 기계 검색 후 검색내용 화면에 바인딩
export type Machine = {
  id: string;
  make: string;
  name: string;
  code: string;
  createdAt: string;
};

interface MachineSearchBoxProps {
  onSelect?: (machine: Machine | null) => void;
  type?: "CNC" | "PMS";
}
export const MachineSearchBox = ({ onSelect, type = "PMS" }: MachineSearchBoxProps) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { closeModal } = useModal();
  const handleRowClick = (id: string) => {
    setSelectedId(id === selectedId ? null : id); // toggle
  };

  const machineData = type === "CNC" ? machineCNCData : machineMockData; // Placeholder for CNC data, replace with actual data if needed

  const selectedMachine = machineData.find((m) => m.id === selectedId) ?? null;

  return (
    <Box h="auto" w="auto">
      <Flex gap="md" direction={"column"}>
        <Flex gap="md">
          <Select data={["기계 제조사", "기계이름", "제조번호"]} w="8rem" />
          <TextInput placeholder="검색어를 입력하세요." w="40rem" />
          <Button>검색</Button>
        </Flex>
        <Table striped withBorder withColumnBorders>
          <thead>
            <tr>
              <th>기계 제조사</th>
              <th>기계 이름</th>
              <th>제조 번호</th>
            </tr>
          </thead>
          <tbody>
            {machineData.map((machine) => {
              return (
                <tr
                  key={machine.id}
                  onClick={() => handleRowClick(machine.id)}
                  style={{
                    backgroundColor: machine.id === selectedId ? "#e0f7fa" : undefined,
                    cursor: "pointer",
                  }}
                >
                  <td>{machine.make}</td>
                  <td>{machine.name}</td>
                  <td>{machine.code}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Flex gap="sm">
          <Button w="50%" color="gray" onClick={() => closeModal("")}>
            취소
          </Button>
          {/* 선택 시 데이터 들어가게 */}
          <Button
            w="50%"
            onClick={() => {
              if (onSelect) onSelect(selectedMachine);
            }}
            disabled={!selectedMachine}
          >
            선택
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};
